export default __webpack_public_path__ + "static/media/workshop_agenda.a2925046.png";